import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { historyReplacePathname } from 'actions/core/navigation'
import { useGetUserQuery } from 'common'
import { useLazyFetchNewEventTypeQuery, useSetEventType } from 'features/event_type_provider'

import { useEventTypeEditorSidebar } from '../../../../../../hooks'
import { isSameMembership } from '../../helpers'

const getHomePath = (scope) => `/app/scheduling/meeting_types/${scope}`

export const useSelectSoloGroupHost = (selectedMembership, callback) => {
  const dispatch = useDispatch()
  const { type, kind, poolingType, ownerType } = useEventTypeEditorSidebar()
  const { data: currentUser } = useGetUserQuery()
  const [fetchNewEventType] = useLazyFetchNewEventTypeQuery()
  const setEventType = useSetEventType()

  return useCallback((membership) => {
    if (callback) { callback() }

    if (isSameMembership(selectedMembership, membership)) return

    fetchNewEventType({
      type,
      kind,
      poolingType,
      ownerType,
      ownerId: parseInt(membership.user_id, 10),
      onSuccess: (response) => setEventType(response)
    })

    const userId = currentUser.id === membership.user_id ? 'me' : membership.user_id
    dispatch(historyReplacePathname(getHomePath(`user/${userId}`)))
  }, [
    callback,
    currentUser.id,
    dispatch,
    fetchNewEventType,
    kind,
    ownerType,
    poolingType,
    selectedMembership,
    setEventType,
    type
  ])
}
